function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { createContext, useContext, useReducer } from "react";
import { node } from "prop-types";
import { HIDE_DROPDOWN_MENU, SET_DROPDOWN_MENU, SET_TRIGGER_BUTTON, SHOW_DROPDOWN_MENU, SET_DROPDOWN_MENU_POSITION } from "#library/components/Dropdown/Dropdown.actions";
export var initialState = {
  isDropdownMenuVisible: false,
  dropdownMenu: null,
  dropdownMenuRef: null,
  triggerButton: {
    height: 0,
    top: 0,
    width: 0
  }
};
var DropdownContext = /*#__PURE__*/createContext();
var dropdownReducer = function dropdownReducer(state, action) {
  switch (action.type) {
    case SHOW_DROPDOWN_MENU:
      return _objectSpread(_objectSpread({}, state), {}, {
        isDropdownMenuVisible: true
      });
    case SET_DROPDOWN_MENU:
      return _objectSpread(_objectSpread({}, state), {}, {
        dropdownMenu: action.payload.dropdownMenu
      });
    case SET_TRIGGER_BUTTON:
      return _objectSpread(_objectSpread({}, state), {}, {
        triggerButton: action.payload.triggerButton
      });
    case HIDE_DROPDOWN_MENU:
      return _objectSpread(_objectSpread({}, state), {}, {
        isDropdownMenuVisible: false
      });
    case SET_DROPDOWN_MENU_POSITION:
      return _objectSpread(_objectSpread({}, state), {}, {
        dropdownMenuPosition: action.payload.position
      });
    default:
      {
        throw new Error("Unhandled action type: ".concat(action.type));
      }
  }
};
export var DropdownProvider = function DropdownProvider(_ref) {
  var children = _ref.children;
  var _useReducer = useReducer(dropdownReducer, initialState),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  var value = {
    state: state,
    dispatch: dispatch
  };
  return /*#__PURE__*/React.createElement(DropdownContext.Provider, {
    value: value
  }, children);
};
DropdownProvider.propTypes = {
  children: node.isRequired
};
export var useDropdown = function useDropdown() {
  var context = useContext(DropdownContext);
  if (context === undefined) {
    throw new Error("`useDropdown` must be used within a `DropdownProvider`");
  }
  return context;
};